const quota_table = {
    quota: {
        title: 'پایه‌ها',
        base_price: 'قیمت پایه',
        mau_limit: 'محدودیت MAU',
        included_tokens: 'توکن‌های شامل',
    },
    application: {
        title: 'برنامه‌ها',
        total: 'کل برنامه‌ها',
        m2m: 'برنامه‌های ماشین-به-ماشین',
        third_party: 'برنامه‌های شخص ثالث OIDC/OAuth',
        saml_app: 'برنامه‌های SAML',
    },
    resource: {
        title: 'منابع API',
        resource_count: 'تعداد منابع',
        scopes_per_resource: 'مجوزها به ازای هر منبع',
    },
    branding: {
        title: 'رابط کاربری و برندینگ',
        custom_domain: 'دامنه سفارشی',
        custom_css: 'CSS سفارشی',
        logo_and_favicon: 'لوگو و فاویکون',
        bring_your_ui: 'رابط کاربری خود را بیاورید',
        dark_mode: 'حالت تاریک',
        i18n: 'بین‌المللی‌سازی',
    },
    user_authn: {
        title: 'احراز هویت کاربر',
        omni_sign_in: 'ورود همه‌جانبه',
        password: 'رمز عبور',
        passwordless: 'بدون رمز عبور - ایمیل و SMS',
        email_connector: 'اتصال‌دهنده ایمیل',
        sms_connector: 'اتصال‌دهنده SMS',
        social_connectors: 'اتصال‌دهنده‌های اجتماعی',
        standard_connectors: 'اتصال‌دهنده‌های استاندارد',
        built_in_email_connector: 'اتصال‌دهنده ایمیل داخلی',
        mfa: 'احراز هویت چندعاملی',
        sso: 'ورود یکپارچه سازمانی',
        impersonation: 'جعل هویت',
    },
    user_management: {
        title: 'مدیریت کاربران',
        user_management: 'مدیریت کاربران',
        roles: 'نقش‌ها',
        machine_to_machine_roles: 'نقش‌های ماشین-به-ماشین',
        scopes_per_role: 'مجوزها به ازای هر نقش',
    },
    organizations: {
        title: 'سازمان‌ها',
        organizations: 'سازمان‌ها',
        organization: 'سازمان',
        organization_count: 'تعداد سازمان‌ها',
        allowed_users_per_org: 'کاربران به ازای هر سازمان',
        invitation: 'دعوت‌نامه (Management API)',
        org_roles: 'نقش‌های سازمانی',
        org_permissions: 'مجوزهای سازمانی',
        just_in_time_provisioning: 'تأمین به‌موقع',
    },
    support: {
        title: 'پشتیبانی',
        community: 'انجمن',
        customer_ticket: 'پشتیبانی از طریق تیکت',
        premium: 'پریمیوم',
        email_ticket_support: 'پشتیبانی از طریق تیکت ایمیل',
        discord_private_channel: 'کانال خصوصی Discord',
        premium_support: 'پشتیبانی پریمیوم',
        developer_onboarding: 'آموزش توسعه‌دهنده',
        solution_engineer_support: 'مهندس راه‌حل',
        sla: 'SLA',
        dedicated_computing_resources: 'منابع محاسباتی اختصاصی',
    },
    compliance: {
        title: 'انطباق',
        soc2_compliant: 'مطابق با SOC2',
        soc2_report: 'گزارش SOC2',
        hipaa_or_baa_report: 'گزارش HIPAA/BAA',
    },
    developers_and_platform: {
        title: 'توسعه‌دهندگان و پلتفرم',
        hooks: 'وب‌هوک‌ها',
        audit_logs_retention: 'نگهداری لاگ‌های حسابرسی',
        jwt_claims: 'ادعاهای JWT',
        tenant_members: 'اعضای مستأجر',
    },
    unlimited: 'نامحدود',
    contact: 'تماس',
    monthly_price: '‎${{value, number}}/ماه',
    days: '{{count, number}} روز',
    days_other: '{{count, number}} روز',
    add_on: 'افزونه',
    tier: 'سطح{{value, number}}: ',
    million: '{{value, number}} میلیون',
    mau_tip: 'MAU (کاربر فعال ماهانه) به معنای تعداد کاربران منحصربه‌فردی است که حداقل یک توکن با Logto در یک دوره صورت‌حساب مبادله کرده‌اند.',
    tokens_tip: 'انواع توکن‌هایی که توسط Logto صادر می‌شوند، از جمله توکن دسترسی، توکن تازه‌سازی و غیره.',
    mao_tip: 'MAO (سازمان فعال ماهانه) به معنای تعداد سازمان‌های منحصربه‌فردی است که حداقل یک MAU (کاربر فعال ماهانه) در یک دوره صورت‌حساب دارند.',
    third_party_tip: 'از Logto به عنوان ارائه‌دهنده هویت OIDC برای ورود برنامه‌های شخص ثالث و اعطای مجوز استفاده کنید.',
    included: '{{value, number}} شامل',
    included_mao: '{{value, number}} MAO شامل',
    extra_quota_price: 'سپس ${{value, number}} در ماه / هر کدام پس از آن',
    extra_token_price: 'سپس ${{value, number}} در ماه / هر {{amount, number}} پس از آن',
    per_month_each: '‎${{value, number}} در ماه / هر کدام',
    extra_mao_price: 'سپس ${{value, number}} به ازای هر MAO',
    per_month: '‎${{value, number}} در ماه',
    per_member: 'سپس ${{value, number}} به ازای هر عضو',
};
export default Object.freeze(quota_table);
